<script setup>
import { storeToRefs } from 'pinia';
import { useAuthStore } from '@/stores/auth.store.js';
import axios from "axios";

const authStore = useAuthStore();
const { user } = storeToRefs(authStore);

const logout = async () => {

  try {
    const response = await axios.post(import.meta.env.VITE_API_BACKEND_URL + '/api/auth/sign-out', {
      withCredentials: true
    });

    if (response) {
      window.location.href = '/login'

    } else {
      throw new Error("Failed");
    }

  } catch (e) {

  } finally {
  }
}

</script>

<template>
    <nav class="navbar navbar-expand-lg navbar-light">
        <div class="container-fluid">

            <a class="navbar-brand" href="#"><img style="width:180px;" src="/AE_logo_branding_purple.png" alt="IJ Archive Explorer"></a>

            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span class="navbar-toggler-icon"></span>
            </button>

            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav me-auto mb-2 mb-lg-0 px-3">
                    <li class="nav-item">
                      <a class="nav-link active" aria-current="page" href="/">File manager</a>
                    </li>
                    <li v-if="user" class="nav-item">
                      <a class="nav-link" href="/uploads">My uploads</a>
                    </li>
                    <li v-if="user && user.role && user.role.name=='admin'" class="nav-item">
                      <a class="nav-link" href="/user-manager">User manager</a>
                    </li>
                    <li v-if="user && user.role && user.role.name=='admin'" class="nav-item">
                      <a class="nav-link" href="/role-manager">Role manager</a>
                    </li>
                    <li v-if="user && user.permissions && user.permissions.includes('manage user directories')" class="nav-item">
                      <a class="nav-link" href="/directory-manager">Directory manager</a>
                    </li>
                </ul>

                <ul class="navbar-nav mb-2 mb-lg-0 d-flex px-3">
                    <li class="nav-item dropdown">
                      <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                        <em>{{user && user.username}}</em>
                      </a>



                      <ul v-if="user" class="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">

                        <template v-if="user.role && user.role.name=='admin'">
                          <li><a class="dropdown-item text-center" href="/user-manager">User manager</a></li>
                          <li><hr class="dropdown-divider"></li>
                          <li><a class="dropdown-item text-center" href="/role-manager">Role manager</a></li>
                          <li><hr class="dropdown-divider"></li>
                        </template>

                        <template v-if="user.permissions && user.permissions.includes('manage user directories')">
                          <li><a class="dropdown-item text-center" href="/directory-manager">Directory manager</a></li>
                          <li><hr class="dropdown-divider"></li>
                        </template>

                        <li><a class="dropdown-item text-center" href="/uploads">My uploads</a></li>
                        <li><hr class="dropdown-divider"></li>
                        <li><a class="dropdown-item text-center" href="/account">Account</a></li>
                        <li><hr class="dropdown-divider"></li>
                        <li><a class="dropdown-item text-center" style="cursor: pointer" @click="logout()">Sign out</a></li>
                      </ul>


                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>

<style scoped>
    nav.navbar {
        background-color: #850f5f;
    }
    a.nav-link, a.nav-link.active {
        color: #fff;
    }
    ul.dropdown-menu {
        background-color: #f2f2f2;
    }
    .dropdown-item.active, .dropdown-item:active {
        color: #fff;
        background-color: var(--purple);
    }
</style>